import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import { grey } from '@material-ui/core/colors';


import {Checkbox, Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core'
import {Container, Box, Typography} from '@material-ui/core'
import {Button, TextField} from '@material-ui/core';
import {Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';

import {ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { getIndexByID, getObjectByID } from '../../../api/helpers';
import { CheckBox, CheckBoxTwoTone, Label } from '@material-ui/icons';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

class SelectGroupsDialog_ extends React.Component{

    constructor(props){
        super(props)

        //console.log('SelectGroupsDialog_')
        //console.log(props)
        
        let panelsExpanded = {}
        let defaultNetID = this.props.networkID ? this.props.networkID : ( this.props.networks ? this.props.networks[0].ID : null)
        if(defaultNetID) panelsExpanded[defaultNetID] = true

        this.state = {
            changed: false,
            panelsExpanded: panelsExpanded,
            filter: '',
            groups: this.props.groups,
            checked: false
        }

        this.handleSelect = this.handleSelect.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleFilterInput = this.handleFilterInput.bind(this)
        this.handleSelectionAllClick = this.handleSelectionAllClick.bind(this) 
    }



    handleSelect(){
        if(this.validate()){
            this.props.onAction({type: 'SELECT_GROUPS_DIALOG_SELECT', groups: this.state.groups })
        }
    }

    handleClose(){
        this.props.onAction({type: 'SELECT_GROUPS_DIALOG_CLOSE'})
    }

    handleFilterInput(event){
        const val =  event.target.value
        this.setState({[event.target.name]: val})
    }

    validate(){
        let error = false
        return !error;
    }


    togglePanel(event, expanded, panel){
        this.setState(state => {
            state.panelsExpanded[panel] = expanded
            return state
        })
    }

    select(netID, groupID){
        let network = getObjectByID(netID, this.props.networks)
        let group = getObjectByID(groupID, network.groups)

        let selected = {
            networkID: netID,
            groupID: group.ID,
            group: group.Name
        }

        this.setState({selected: selected})
    }

    getGroups(groups){
        groups.sort((item1, item2) => (item1.Name > item2.Name))
        return groups
    }

    networkSelected(net){
        let selected = false
        net.groups.forEach(group => {
            selected = selected || this.groupSelected(group)
        });
        //console.log("networkSelected")
        //console.log(selected)
        return selected
    }

    groupSelected(group){
        let item = getObjectByID(group.ID, this.state.groups, 'GroupID')
        let selected = item!==null

        //console.log("groupSelected")
        //console.log(selected)

        return selected
    }

    selectAll(network, checked){
        let groups = this.state.groups

        network.groups.forEach(group => {
            let index = getIndexByID(groups.ID, groups, 'GroupID')
            if(checked && index===null){
                groups.push({GroupID: group.ID, NetID: network.ID})
            }
            if(!checked && index!==null){
                groups.splice(index, 1)
            }
        })

        this.setState({groups: groups})
    }

    selectGroup(group, checked){
        //console.log('selectGroup')
        //console.log(group)
        //console.log(this.props.networks)
        let groups = this.state.groups
        //console.log(groups)
        let net = getObjectByID(group.NetworkID, this.props.networks)
        //console.log(net)
        let index = getIndexByID(group.ID, groups, 'GroupID')
        //console.log(index)
        if(checked && index===null){
            groups.push({GroupID: group.ID, NetworkID: net.ID})
        }
        if(!checked && index!==null){
            groups.splice(index, 1)
        }
        this.setState({groups: groups})
    }


    handleSelectionAllClick(network){
        return (event)=>{
            this.selectAll(network, event.target.checked)
        }
    }

    handleSelectionItem(group){
        return (event)=>{
            this.selectGroup(group, event.target.checked)
        }
    }


    getNetworks(){
        let networks = []
        if(this.props.networkID){
            networks = this.props.networks.filter(net => net.ID==this.props.networkID)
        }else{
            networks = this.props.networks
        }

        let filter = this.state.filter.toLowerCase()
        networks = networks.map(net => this.getNetwork(net, filter))

        return networks
    }

    getNetwork(network, filter){
        let net
        if(filter){
            net = {
                ID: network.ID, 
                Name: network.Name,
                groups: network.groups.filter(
                    item => item.Name.toLowerCase().indexOf(filter) >= 0 //&& item.Type!=10
                )
            }
        }else{
            net = {
                ID: network.ID, 
                Name: network.Name,
                groups: network.groups //.filter(item => item.Type!=10)
            }
        }

        return net
    }


    render(){
        const {t} = this.props

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            icon:{
                width: 30
            },
            addIcon: {
                color: 'white'
            }
        };

        const title = t('SelectItem')

        let networks = this.getNetworks() 

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:300}}>        

            <Box textAlign="center">
                <TextField
                    name="filter"
                    id="filter"
                    onChange={this.handleFilterInput}
                    label={t("Filter")}
                    value={this.state.filter}
                    style={{width:'100%'}}
                    error={false}
                    autoComplete="new-password"
                />
            </Box>

            {networks.map(net=>(

            <ExpansionPanel key={net.ID}
                expanded={this.state.panelsExpanded[net.ID]==undefined?false:this.state.panelsExpanded[net.ID]} 
                onChange={(event, expanded) => this.togglePanel(event, expanded, net.ID)}>
                <ExpansionPanelSummary style={{background: grey[300], marginLeft:0}} expandIcon={<ExpandMoreIcon />}>
                    <Typography>{net.Name}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails style={{display: 'block', margin:0, padding:0}}>
                    
                    <Table size="small">

                        <TableHead>
                            <TableRow>
                                <TableCell style={styles.head}>

                                    <label>
                                    <Checkbox
                                        checked={this.networkSelected(net)}

                                        icon={<CheckBoxOutlineBlankIcon style={{color:"white"}} />}
                                        checkedIcon={<CheckBox style={{color:"white"}} />}

                                        name={'net_'+net.ID}
                                        onChange={this.handleSelectionAllClick(net)}>
                                    </Checkbox>
                                    {t('SelectAll')}
                                    </label>                                
                                    
                                </TableCell>
                            </TableRow>
                        </TableHead>
                    
                    
                        <TableBody>
                        {this.getGroups(net.groups).map(group=>
                            <TableRow key={group.ID}>
                                <TableCell>
                                    <label>
                                    <Checkbox 
                                        checked={this.groupSelected(group)}
                                        onChange={this.handleSelectionItem(group)}></Checkbox>
                                    {group.Name}
                                    </label>
                                </TableCell>
                            </TableRow>
                        )}
                        </TableBody>
                    </Table>

                </ExpansionPanelDetails>
            </ExpansionPanel>
            ))}

            

        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSelect} variant="contained" color="primary">
            {t('Ok')}
        </Button>
        <Button onClick={this.handleClose} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}

export const SelectGroupsDialog = withTranslation()(SelectGroupsDialog_);